import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectPaymentMethod } from './paymentMethodsSlice';
import { callPreTransfer } from '../transfer/transferSlice';

import Select from '../../components/BaseSelect';

const CustomOption = ({ selectProps, isSelected, innerProps, data }) => {
  let className = `${selectProps.classNamePrefix}__option`;

  if (isSelected) {
    className += ' react-select__option--is-selected';
  }

  return (
    <div
      className={className}
      {...innerProps}
      style={{ backgroundImage: `url(${data.logoLink})`, backgroundSize: '30px' }}
    >
      {data.name}
    </div>
  );
};

const SingleValue = ({ hasValue, getValue, selectProps }) => {
  let className = `${selectProps.classNamePrefix}__single-value`;

  if (!hasValue) {
    return null;
  }

  const data = getValue()[0];

  return (
    <div
      className={className}
      style={{ backgroundImage: `url(${data.logoLink})`, backgroundSize: '30px', marginTop: -8 }}
    >
      {data.name}
    </div>
  );
};

export default function PaymentMethodSelect() {
  const { paymentMethods, selected } = useSelector((state) => state.paymentMethods);

  const dispatch = useDispatch();

  const handlePaymentMethodChange = async (o) => {
    dispatch(selectPaymentMethod(o.type));

    if (o.type === 2) {
      dispatch(callPreTransfer(o.type));
    }
  };

  return (
    <div className="form-group">
      <Select
        value={paymentMethods.find((c) => c.type === selected)}
        onChange={handlePaymentMethodChange}
        className="payment-methods-select"
        options={paymentMethods}
        components={{ Option: CustomOption, SingleValue }}
        isSearchable={false}
        isDisabled={false}
      />
    </div>
  );
}
